module.exports = __webpack_public_path__ + "static/404Page-b9e629beb30ff961922287825e650e93.jpg";